import React from 'react';

/**
 * Templates des documents légaux OMAD Services
 * Version corrigée et complète avec toutes les clauses obligatoires
 */

// Template du Contrat de Prestation de Mandat
export const MandatTemplate = ({ client, companyInfo, contrat }) => `
<!DOCTYPE html>
<html lang="fr">
<head>
    <meta charset="UTF-8">
    <meta name="viewport" content="width=device-width, initial-scale=1.0">
    <title>Contrat de Prestation de Mandat - OMAD Services</title>
    <style>
        body { font-family: Arial, sans-serif; line-height: 1.6; margin: 0; padding: 20px; }
        .header { text-align: center; margin-bottom: 30px; border-bottom: 2px solid #333; padding-bottom: 20px; }
        .section { margin-bottom: 25px; }
        .section-title { font-weight: bold; font-size: 16px; margin-bottom: 10px; color: #2c3e50; }
        .signature-area { margin-top: 50px; border-top: 1px solid #ccc; padding-top: 20px; }
        .signature-line { margin-top: 80px; border-bottom: 1px solid #000; width: 300px; }
        .footer { margin-top: 50px; font-size: 12px; color: #666; text-align: center; }
        .highlight { background-color: #fff3cd; padding: 10px; border-left: 4px solid #ffc107; margin: 10px 0; }
    </style>
</head>
<body>
    <div class="header">
        <h1>CONTRAT DE PRESTATION DE MANDAT</h1>
        <h2>OMAD Services – Mandataire de gestion administrative et de mise en relation</h2>
    </div>

    <div class="section">
        <p><strong>Entre les soussignés :</strong></p>
        <p><strong>OMAD Services</strong><br>
        SAS au capital de 500,00 € – RCS Bourges n° 922 592 662<br>
        Siège social : 30 bis Rue des Bondoires – 18230 Saint-Doulchard<br>
        Représentée par Mme Virginie Cahagne, Présidente,<br>
        (ci-après « le Mandataire » ou « OMAD Services »)</p>

        <p><strong>Et</strong></p>
        <p><strong>${client?.firstName || '______'} ${client?.lastName || '______'}</strong><br>
        Domicilié(e) à ${client?.address || '______'}<br>
        Téléphone : ${client?.phone || '______'}<br>
        (ci-après « le Mandant » ou « le Client »)</p>
    </div>

    <div class="section">
        <div class="section-title">Article 1 – Objet</div>
        <p>Le présent contrat constitue un mandat civil au sens des articles 1984 et suivants du Code civil.</p>
        <p>Le Mandant confie à OMAD Services une mission de gestion administrative, organisationnelle et de suivi afférente à l'emploi d'un intervenant à domicile.</p>
    </div>

    <div class="section">
        <div class="section-title">Article 2 – Missions du Mandataire</div>
        <p>OMAD Services s'engage à :</p>
        <ul>
            <li>Rechercher et sélectionner des intervenants qualifiés (vérification diplômes, références)</li>
            <li>Présenter au Mandant des candidatures adaptées</li>
            <li>Aider à la rédaction du contrat de travail (Particulier Employeur ↔ Intervenant)</li>
            <li>Effectuer les démarches administratives : CESU/URSSAF, paie, congés, attestations</li>
            <li>Conseiller sur les aides (APA, exonérations, crédit d'impôt)</li>
            <li>Suivre la qualité des interventions (évaluations, enquêtes de satisfaction)</li>
        </ul>
    </div>

    <div class="section">
        <div class="section-title">Article 3 – Obligations du Mandant</div>
        <p>Le Mandant s'engage à :</p>
        <ul>
            <li>Fournir des informations exactes et à jour</li>
            <li>Assumer son rôle d'employeur légal conformément à la Convention Collective Nationale Particulier Employeur & Emploi à Domicile (IDCC 3239)</li>
            <li>Régler directement les salaires et charges sociales de l'intervenant</li>
            <li>Souscrire une assurance responsabilité civile employeur</li>
            <li>Fournir un environnement de travail sûr et adapté</li>
            <li>Régler les frais de mandat et annexes à OMAD Services</li>
        </ul>
    </div>

    <div class="section">
        <div class="section-title">Article 4 – Tarification & Paiement</div>
        <p>Les frais de mandat sont facturés selon la grille en vigueur :</p>
        <table style="width: 100%; border-collapse: collapse; margin: 10px 0;">
            <tr style="background-color: #f8f9fa;">
                <th style="border: 1px solid #ddd; padding: 8px; text-align: left;">Volume horaire hebdo</th>
                <th style="border: 1px solid #ddd; padding: 8px; text-align: left;">Tarif TTC / heure</th>
            </tr>
            <tr>
                <td style="border: 1px solid #ddd; padding: 8px;">≤ 10 h/sem.</td>
                <td style="border: 1px solid #ddd; padding: 8px;">6,00 €</td>
            </tr>
            <tr>
                <td style="border: 1px solid #ddd; padding: 8px;">11–25 h/sem.</td>
                <td style="border: 1px solid #ddd; padding: 8px;">5,40 €</td>
            </tr>
            <tr>
                <td style="border: 1px solid #ddd; padding: 8px;">26–40 h/sem.</td>
                <td style="border: 1px solid #ddd; padding: 8px;">4,20 €</td>
            </tr>
            <tr>
                <td style="border: 1px solid #ddd; padding: 8px;">> 40 h/sem.</td>
                <td style="border: 1px solid #ddd; padding: 8px;">3,00 €</td>
            </tr>
        </table>
        <p>Facturation mensuelle, paiement à réception (virement, chèque, prélèvement).</p>
        <p>Révision automatique possible en cas d'évolution légale (SMIC, charges, fiscalité).</p>
    </div>

    <div class="section">
        <div class="section-title">Article 5 – Durée & Résiliation</div>
        <p>Contrat conclu pour une durée indéterminée à compter du ${contrat?.startDate || '___ / ___ / _____'}.</p>
        <p>Résiliation par LRAR avec préavis de 2 mois.</p>
        <p>Résiliation immédiate en cas de manquement grave ou décès du bénéficiaire.</p>
        <p>Suspension possible en cas d'impayés après mise en demeure restée sans effet (15 jours).</p>
    </div>

    <div class="section">
        <div class="section-title">Article 6 – Force majeure</div>
        <p>Les obligations des parties sont suspendues en cas de force majeure (grève, pandémie, catastrophe naturelle, décision administrative, etc.).</p>
        <p>Si la suspension excède 30 jours, chaque partie peut résilier sans indemnité.</p>
    </div>

    <div class="section">
        <div class="section-title">Article 7 – Médiation consommation</div>
        <div class="highlight">
            <p><strong>Conformément aux articles L.612-1 et suivants du Code de la consommation,</strong> le Client consommateur peut recourir gratuitement à un médiateur de la consommation en cas de litige non résolu avec OMAD Services.</p>
            <p><strong>Médiateur désigné :</strong> [Nom du médiateur agréé, ex. Médiation de la consommation AME Conso – www.mediationconso-ame.com]</p>
        </div>
    </div>

    <div class="section">
        <div class="section-title">Article 8 – Droit de rétractation</div>
        <div class="highlight">
            <p><strong>En cas de signature à distance ou hors établissement,</strong> le Client bénéficie d'un délai légal de 14 (quatorze) jours pour exercer son droit de rétractation, sans avoir à justifier de motifs ni à supporter de pénalités, conformément aux articles L.221-18 et suivants du Code de la consommation.</p>
            <p>Le délai court à compter de la signature du contrat. Pour exercer ce droit, le Client doit notifier sa décision par courrier recommandé ou courriel avec accusé de réception à OMAD Services.</p>
        </div>
    </div>

    <div class="section">
        <div class="section-title">Article 9 – Protection des données personnelles</div>
        <p>Données traitées conformément au RGPD et à la Loi Informatique & Libertés.</p>
        <p>Durée de conservation : durée du contrat + 5 ans max (prescription légale).</p>
        <p>Responsable de traitement : OMAD Services – DPO : dpo@omadservices.com</p>
        <p>Droits : accès, rectification, opposition, effacement, portabilité.</p>
    </div>

    <div class="section">
        <div class="section-title">Article 10 – Assurances</div>
        <p>OMAD Services déclare être couvert par une Responsabilité Civile Professionnelle.</p>
        <p>Le Mandant doit maintenir une RC employeur couvrant l'emploi de l'intervenant.</p>
    </div>

    <div class="section">
        <div class="section-title">Article 11 – Litiges</div>
        <p>Réclamation écrite adressée à OMAD Services (réponse sous 30 jours).</p>
        <p>À défaut, recours au médiateur désigné.</p>
        <p>En dernier ressort, compétence des juridictions du siège social d'OMAD Services.</p>
    </div>

    <div class="section">
        <div class="section-title">Article 12 – Dispositions finales</div>
        <p>Le présent contrat, accompagné de la grille tarifaire, des CGS, du Livret d'accueil et du Règlement intérieur, constitue l'accord complet entre les parties.</p>
        <p>Signatures manuscrites ou électroniques acceptées.</p>
    </div>

    <div class="signature-area">
        <p>Fait à Saint-Doulchard, le ___ / ___ / ____</p>
        
        <div style="display: flex; justify-content: space-between; margin-top: 50px;">
            <div>
                <p>Le Mandant (client) :</p>
                <div class="signature-line"></div>
                <p style="text-align: center; margin-top: 5px;">${client?.firstName || '______'} ${client?.lastName || '______'}</p>
            </div>
            <div>
                <p>OMAD Services :</p>
                <div class="signature-line"></div>
                <p style="text-align: center; margin-top: 5px;">Virginie Cahagne, Présidente</p>
            </div>
        </div>
    </div>

    <div class="footer">
        <p>Document généré le ${new Date().toLocaleDateString('fr-FR')} - OMAD Services SAS - RCS Bourges 922 592 662</p>
    </div>
</body>
</html>
`;

// Template des Conditions Générales de Service
export const CGSTemplate = ({ client, companyInfo }) => `
<!DOCTYPE html>
<html lang="fr">
<head>
    <meta charset="UTF-8">
    <meta name="viewport" content="width=device-width, initial-scale=1.0">
    <title>Conditions Générales de Service - OMAD Services</title>
    <style>
        body { font-family: Arial, sans-serif; line-height: 1.6; margin: 0; padding: 20px; }
        .header { text-align: center; margin-bottom: 30px; border-bottom: 2px solid #333; padding-bottom: 20px; }
        .section { margin-bottom: 25px; }
        .section-title { font-weight: bold; font-size: 16px; margin-bottom: 10px; color: #2c3e50; }
        .highlight { background-color: #fff3cd; padding: 10px; border-left: 4px solid #ffc107; margin: 10px 0; }
        .footer { margin-top: 50px; font-size: 12px; color: #666; text-align: center; }
    </style>
</head>
<body>
    <div class="header">
        <h1>CONDITIONS GÉNÉRALES DE SERVICE</h1>
        <h2>OMAD SERVICES – Mandataire de gestion administrative et de mise en relation</h2>
    </div>

    <div class="section">
        <div class="section-title">Article 1 – Définitions</div>
        <p><strong>OMAD Services :</strong> Société par Actions Simplifiée (SAS) agissant en qualité de mandataire administratif et de mise en relation.</p>
        <p><strong>Client :</strong> Particulier employeur recourant aux services d'OMAD Services.</p>
        <p><strong>Intervenant :</strong> Salarié du Client, recruté et déclaré via CESU ou dispositif équivalent.</p>
        <p><strong>Prestations :</strong> Ensemble des services administratifs, de mise en relation et de suivi fournis par OMAD Services.</p>
    </div>

    <div class="section">
        <div class="section-title">Article 2 – Objet</div>
        <p>Les présentes CGS définissent les conditions dans lesquelles OMAD Services propose ses services de gestion administrative, de mise en relation et de suivi qualité pour les interventions à domicile.</p>
    </div>

    <div class="section">
        <div class="section-title">Article 3 – Champ d'application</div>
        <p>Les CGS s'appliquent à toute prestation réalisée par OMAD Services.</p>
        <p>En cas de contradiction, les conditions particulières (contrat de mandat, devis) prévalent.</p>
    </div>

    <div class="section">
        <div class="section-title">Article 4 – Mandat & Autorisation</div>
        <p>Le Client signe un mandat civil confiant à OMAD Services l'exécution des démarches administratives nécessaires (déclarations CESU, URSSAF, aides APA/PCH, crédit d'impôt).</p>
        <p>Le Client reste l'employeur légal de l'intervenant.</p>
    </div>

    <div class="section">
        <div class="section-title">Article 5 – Prestations d'OMAD Services</div>
        <p>OMAD Services peut réaliser :</p>
        <ul>
            <li>Sélection et présentation d'intervenants qualifiés</li>
            <li>Aide à la rédaction des contrats de travail CESU</li>
            <li>Déclarations sociales, fiches de paie, attestations</li>
            <li>Gestion des plannings, congés et remplacements</li>
            <li>Assistance administrative et conseils sur les aides</li>
            <li>Suivi qualité (enquêtes, visites, réclamations)</li>
        </ul>
        <p>OMAD Services est tenu à une obligation de moyens et non de résultat.</p>
    </div>

    <div class="section">
        <div class="section-title">Article 6 – Devis, Tarification & Paiement</div>
        <p>Chaque prestation fait l'objet d'un devis détaillé (heures, tarifs, frais mandat, frais déplacement, aides mobilisables).</p>
        <p>Facturation mensuelle.</p>
        <p>Moyens de paiement : virement, chèque, CESU.</p>
        <p>Retard de paiement : pénalités légales + indemnité forfaitaire de 40 € (art. L441-10 C. Com.).</p>
        <p>OMAD Services peut suspendre les prestations en cas d'impayés après mise en demeure restée sans effet (15 jours).</p>
    </div>

    <div class="section">
        <div class="section-title">Article 7 – Droit de rétractation</div>
        <div class="highlight">
            <p><strong>En cas de signature à distance ou hors établissement,</strong> le Client bénéficie d'un délai de rétractation de 14 jours (art. L221-18 Code conso).</p>
            <p>La demande doit être adressée à OMAD Services par courrier recommandé ou email avec accusé de réception.</p>
        </div>
    </div>

    <div class="section">
        <div class="section-title">Article 8 – Durée, Résiliation & Suspension</div>
        <p>Contrat à durée indéterminée.</p>
        <p>Résiliation possible par LRAR avec préavis de 2 mois.</p>
        <p>Résiliation immédiate en cas de manquement grave, danger, non-paiement, ou décès du bénéficiaire.</p>
        <p>Suspension temporaire possible en cas de force majeure ou de non-paiement.</p>
    </div>

    <div class="section">
        <div class="section-title">Article 9 – Force majeure</div>
        <p>Les obligations sont suspendues en cas de force majeure (catastrophe naturelle, pandémie, grève, décision administrative).</p>
        <p>Résiliation possible si l'empêchement dure plus de 30 jours.</p>
    </div>

    <div class="section">
        <div class="section-title">Article 10 – Obligations du Client</div>
        <p>Le Client doit :</p>
        <ul>
            <li>Fournir des informations exactes et actualisées</li>
            <li>Respecter ses obligations légales en tant qu'employeur (contrat, déclaration, paiement salaire, respect convention collective)</li>
            <li>Fournir un cadre de travail sûr, hygiénique et adapté</li>
            <li>Maintenir une assurance responsabilité civile couvrant l'emploi d'un salarié à domicile</li>
        </ul>
    </div>

    <div class="section">
        <div class="section-title">Article 11 – Obligations d'OMAD Services</div>
        <p>OMAD Services s'engage à :</p>
        <ul>
            <li>Exercer sa mission avec diligence et professionnalisme</li>
            <li>Sélectionner des intervenants compétents</li>
            <li>Fournir les services administratifs prévus dans le mandat</li>
            <li>Garantir confidentialité et protection des données personnelles</li>
            <li>Répondre aux réclamations dans un délai maximum de 30 jours</li>
        </ul>
    </div>

    <div class="section">
        <div class="section-title">Article 12 – Assurance & Responsabilité</div>
        <p>OMAD Services dispose d'une Responsabilité Civile Professionnelle couvrant les missions de mandataire.</p>
        <p>Le Client reste employeur légal de l'intervenant et assume toutes les obligations sociales et légales liées à cet emploi.</p>
    </div>

    <div class="section">
        <div class="section-title">Article 13 – Protection des données (RGPD)</div>
        <p>Données traitées conformément au RGPD et à la Loi Informatique & Libertés.</p>
        <p>Durée de conservation : durée du contrat + 5 ans max.</p>
        <p>Responsable de traitement : OMAD Services – DPO : dpo@omadservices.com</p>
        <p>Droits : accès, rectification, effacement, opposition, portabilité.</p>
    </div>

    <div class="section">
        <div class="section-title">Article 14 – Médiation à la consommation</div>
        <div class="highlight">
            <p><strong>En cas de litige non résolu,</strong> le Client peut recourir gratuitement à un médiateur de la consommation (art. L612-1 Code conso).</p>
            <p><strong>Médiateur désigné :</strong> [Nom du médiateur agréé]</p>
        </div>
    </div>

    <div class="section">
        <div class="section-title">Article 15 – Réclamations & Litiges</div>
        <p>Toute réclamation doit être adressée par écrit à OMAD Services.</p>
        <p>Réponse sous 30 jours.</p>
        <p>À défaut d'accord amiable ou via médiation, compétence des tribunaux du ressort du siège social d'OMAD Services.</p>
    </div>

    <div class="section">
        <div class="section-title">Article 16 – Modifications des CGS</div>
        <p>OMAD Services peut modifier les présentes CGS.</p>
        <p>Toute modification est notifiée par écrit au Client au moins 30 jours avant application.</p>
    </div>

    <div class="signature-area">
        <p>Fait à Saint-Doulchard, le ___ / ___ / ____</p>
        
        <div style="display: flex; justify-content: space-between; margin-top: 50px;">
            <div>
                <p>Signature du Client :</p>
                <div class="signature-line"></div>
                <p style="text-align: center; margin-top: 5px;">${client?.firstName || '______'} ${client?.lastName || '______'}</p>
            </div>
            <div>
                <p>Signature OMAD Services :</p>
                <div class="signature-line"></div>
                <p style="text-align: center; margin-top: 5px;">Virginie Cahagne, Présidente</p>
            </div>
        </div>
    </div>

    <div class="footer">
        <p>Document généré le ${new Date().toLocaleDateString('fr-FR')} - OMAD Services SAS - RCS Bourges 922 592 662</p>
    </div>
</body>
</html>
`;

// Template du Contrat de Travail
export const ContratTravailTemplate = ({ client, intervenant, contrat }) => `
<!DOCTYPE html>
<html lang="fr">
<head>
    <meta charset="UTF-8">
    <meta name="viewport" content="width=device-width, initial-scale=1.0">
    <title>Contrat de Travail - OMAD Services</title>
    <style>
        body { font-family: Arial, sans-serif; line-height: 1.6; margin: 0; padding: 20px; }
        .header { text-align: center; margin-bottom: 30px; border-bottom: 2px solid #333; padding-bottom: 20px; }
        .section { margin-bottom: 25px; }
        .section-title { font-weight: bold; font-size: 16px; margin-bottom: 10px; color: #2c3e50; }
        .signature-area { margin-top: 50px; border-top: 1px solid #ccc; padding-top: 20px; }
        .signature-line { margin-top: 80px; border-bottom: 1px solid #000; width: 300px; }
        .footer { margin-top: 50px; font-size: 12px; color: #666; text-align: center; }
    </style>
</head>
<body>
    <div class="header">
        <h1>CONTRAT DE TRAVAIL – INTERVENANT À DOMICILE</h1>
        <h2>Accord entre Particulier Employeur et Intervenant</h2>
    </div>

    <div class="section">
        <p><strong>Entre les soussignés :</strong></p>
        <p><strong>Employeur (Particulier)</strong><br>
        ${client?.firstName || '______'} ${client?.lastName || '______'}<br>
        Adresse : ${client?.address || '______'}<br>
        (ci-après « l'Employeur »)</p>

        <p><strong>Et</strong></p>
        <p><strong>Salarié (Intervenant)</strong><br>
        ${intervenant?.firstName || '______'} ${intervenant?.lastName || '______'}<br>
        Né(e) le ${intervenant?.birthDate || '____ / ____ / ______'} à ${intervenant?.birthPlace || '______'}<br>
        Adresse : ${intervenant?.address || '______'}<br>
        N° Sécurité Sociale : ${intervenant?.socialSecurity || '______'}<br>
        (ci-après « le Salarié » ou « l'Intervenant »)</p>
    </div>

    <div class="section">
        <div class="section-title">Article 1 – Objet</div>
        <p>Ce contrat définit les conditions d'emploi du Salarié pour des prestations d'aide à domicile (aide à la personne, ménage, repas, courses, accompagnement, etc.), conformément au Code du travail, au Code de la Sécurité sociale et à la Convention Collective Nationale des Particuliers Employeurs et de l'Emploi à Domicile (IDCC 3239).</p>
    </div>

    <div class="section">
        <div class="section-title">Article 2 – Nature & Durée</div>
        <p>Contrat à Durée ${contrat?.durationType === 'CDD' ? 'Déterminée (CDD)' : 'Indéterminée (CDI)'} ${contrat?.startDate ? `à compter du ${contrat.startDate}` : '______'}</p>
        ${contrat?.durationType === 'CDD' && contrat?.endDate ? `<p>Fin du contrat : ${contrat.endDate}</p>` : ''}
    </div>

    <div class="section">
        <div class="section-title">Article 3 – Période d'essai</div>
        <p>Durée : ${contrat?.trialPeriod || '___'} semaines.</p>
        <p>Pendant cette période, le contrat peut être rompu librement sous réserve des délais de prévenance légaux.</p>
    </div>

    <div class="section">
        <div class="section-title">Article 4 – Fonctions</div>
        <p>Le Salarié exerce les fonctions d'Intervenant(e) à domicile :</p>
        <ul>
            <li>Aide à la toilette, habillage, mobilité</li>
            <li>Préparation & aide aux repas</li>
            <li>Entretien du logement & linge</li>
            <li>Courses & accompagnements</li>
            <li>Soutien moral & social</li>
        </ul>
    </div>

    <div class="section">
        <div class="section-title">Article 5 – Lieu de travail</div>
        <p>Domicile du bénéficiaire : ${client?.address || '______'}</p>
        <p>Déplacements extérieurs uniquement avec accord de l'Employeur.</p>
    </div>

    <div class="section">
        <div class="section-title">Article 6 – Durée & Horaires</div>
        <p>Durée hebdomadaire : ${contrat?.weeklyHours || '___'} heures.</p>
        <p>Horaires définis avec l'Employeur, pouvant varier avec préavis raisonnable.</p>
        <p>Repos hebdomadaire : 2 jours, dont un dimanche (sauf accord).</p>
        <p>Heures supplémentaires rémunérées selon la CCN.</p>
    </div>

    <div class="section">
        <div class="section-title">Article 7 – Rémunération</div>
        <p>Salaire horaire brut : ${contrat?.hourlyRateBrut || '____'} €</p>
        <p>Salaire horaire net : ${contrat?.hourlyRateNet || '____'} €</p>
        <p>Modalités de paiement :</p>
        <ul>
            <li>Déclaration et versement via CESU (ou autre moyen légal)</li>
            <li>Périodicité de paie : mensuelle</li>
            <li>Congés payés : 10 % inclus (ou acquis selon option CESU)</li>
            <li>Majoration dimanche, nuit et jours fériés selon la CCN</li>
        </ul>
        <p><strong>Clause d'évolution salariale :</strong> « Le salaire sera automatiquement ajusté en cas d'évolution du SMIC ou des minima conventionnels, la disposition la plus favorable s'appliquant au salarié. »</p>
    </div>

    <div class="section">
        <div class="section-title">Article 8 – Congés & Absences</div>
        <p>Congés payés : 2,5 jours ouvrables par mois.</p>
        <p>Absence : signalement immédiat + justificatif en cas de maladie.</p>
    </div>

    <div class="section">
        <div class="section-title">Article 9 – Frais professionnels</div>
        <p>Forfait déplacement : 2,50 € par intervention (≤ 10 km AR).</p>
        <p>Au-delà : 0,40 €/km.</p>
        <p>Déplacements exceptionnels sur justificatif.</p>
    </div>

    <div class="section">
        <div class="section-title">Article 10 – Obligations du Salarié</div>
        <ul>
            <li>Exécuter ses missions avec sérieux, bienveillance et discrétion</li>
            <li>Respecter confidentialité et secret professionnel</li>
            <li>Respecter hygiène et sécurité</li>
            <li>Prévenir en cas d'absence ou retard</li>
        </ul>
    </div>

    <div class="section">
        <div class="section-title">Article 11 – Obligations de l'Employeur</div>
        <ul>
            <li>Fournir les informations nécessaires aux missions</li>
            <li>Respecter ses obligations légales (contrat, déclaration, paie, couverture sociale)</li>
            <li>Garantir un environnement de travail sûr</li>
        </ul>
    </div>

    <div class="section">
        <div class="section-title">Article 12 – Résiliation du contrat</div>
        <p>CDI : préavis légal sauf faute grave.</p>
        <p>CDD : rupture uniquement dans les cas prévus par la loi.</p>
        <p>Résiliation à notifier par écrit.</p>
    </div>

    <div class="section">
        <div class="section-title">Article 13 – Force majeure</div>
        <p>Le contrat peut être suspendu ou rompu en cas de force majeure (catastrophe naturelle, pandémie, décision administrative, etc.).</p>
    </div>

    <div class="section">
        <div class="section-title">Article 14 – Protection sociale</div>
        <p>Le salarié bénéficie de la couverture sociale liée à sa déclaration CESU (assurance maladie, retraite, chômage, AT/MP).</p>
    </div>

    <div class="section">
        <div class="section-title">Article 15 – Protection des données personnelles</div>
        <p>Les données du salarié sont traitées conformément au RGPD. Conservation : durée du contrat + 5 ans.</p>
    </div>

    <div class="section">
        <div class="section-title">Article 16 – Médiation à la consommation</div>
        <p>En cas de litige avec OMAD Services agissant comme mandataire administratif, le salarié ou l'employeur peut recourir gratuitement à un médiateur agréé.</p>
    </div>

    <div class="section">
        <div class="section-title">Article 17 – Litiges</div>
        <p>À défaut de résolution amiable, compétence du Conseil de prud'hommes territorialement compétent.</p>
    </div>

    <div class="signature-area">
        <p>Fait à __________, le ___ / ___ / ____</p>
        
        <div style="display: flex; justify-content: space-between; margin-top: 50px;">
            <div>
                <p>Employeur :</p>
                <div class="signature-line"></div>
                <p style="text-align: center; margin-top: 5px;">${client?.firstName || '______'} ${client?.lastName || '______'}</p>
            </div>
            <div>
                <p>Salarié :</p>
                <div class="signature-line"></div>
                <p style="text-align: center; margin-top: 5px;">${intervenant?.firstName || '______'} ${intervenant?.lastName || '______'}</p>
            </div>
        </div>
    </div>

    <div class="footer">
        <p>Document généré le ${new Date().toLocaleDateString('fr-FR')} - OMAD Services SAS - RCS Bourges 922 592 662</p>
    </div>
</body>
</html>
`;

// Template du Livret d'Accueil
export const LivretAccueilTemplate = ({ client, companyInfo }) => `
<!DOCTYPE html>
<html lang="fr">
<head>
    <meta charset="UTF-8">
    <meta name="viewport" content="width=device-width, initial-scale=1.0">
    <title>Livret d'Accueil - OMAD Services</title>
    <style>
        body { font-family: Arial, sans-serif; line-height: 1.6; margin: 0; padding: 20px; }
        .header { text-align: center; margin-bottom: 30px; border-bottom: 2px solid #333; padding-bottom: 20px; }
        .section { margin-bottom: 25px; }
        .section-title { font-weight: bold; font-size: 16px; margin-bottom: 10px; color: #2c3e50; }
        .highlight { background-color: #fff3cd; padding: 10px; border-left: 4px solid #ffc107; margin: 10px 0; }
        .footer { margin-top: 50px; font-size: 12px; color: #666; text-align: center; }
    </style>
</head>
<body>
    <div class="header">
        <h1>LIVRET D'ACCUEIL</h1>
        <h2>OMAD SERVICES – Mandataire de gestion administrative et de mise en relation</h2>
    </div>

    <div class="section">
        <div class="section-title">1. Mot de bienvenue</div>
        <p>Merci de votre confiance. OMAD Services est une société mandataire spécialisée dans l'aide à domicile. Ce livret a pour but de vous informer sur nos missions, vos droits et obligations, ainsi que les garanties légales associées.</p>
    </div>

    <div class="section">
        <div class="section-title">2. Références légales</div>
        <ul>
            <li><strong>Forme juridique :</strong> SAS – RCS Bourges n° 922 592 662</li>
            <li><strong>Code APE :</strong> 8810A – Aide à domicile</li>
            <li><strong>Agrément SAP :</strong> n° __________ (à compléter)</li>
            <li><strong>Dirigeante :</strong> Virginie Cahagne, Présidente</li>
            <li><strong>RC Pro :</strong> [nom de la compagnie – n° police]</li>
        </ul>
    </div>

    <div class="section">
        <div class="section-title">3. Services proposés</div>
        <ul>
            <li>Aide à la personne (toilette, habillage, mobilité)</li>
            <li>Préparation des repas / aide à la prise</li>
            <li>Entretien du logement et du linge</li>
            <li>Courses, accompagnements extérieurs</li>
            <li>Présence de nuit (active / passive)</li>
            <li>Sortie d'hospitalisation</li>
            <li>Aide administrative et démarches simples</li>
        </ul>
    </div>

    <div class="section">
        <div class="section-title">4. Fonctionnement</div>
        <ul>
            <li>Signature d'un contrat de mandat (particulier employeur ↔ OMAD)</li>
            <li>Mise en relation avec l'intervenant choisi</li>
            <li>Déclarations sociales via CESU/URSSAF</li>
            <li>Suivi qualité et remplacement en cas d'absence</li>
            <li>Facturation mensuelle (frais de mandat + déplacements)</li>
        </ul>
    </div>

    <div class="section">
        <div class="section-title">5. Tarification</div>
        <ul>
            <li>Frais de mandat dégressifs (6 €/h → 3 €/h selon volume)</li>
            <li>Frais de déplacement : forfait 2,50 € + 0,40 €/km > 10 km</li>
            <li>Majoration : dimanche +25 %, jours fériés +50 %, 1er mai +100 %</li>
            <li>Droit au crédit d'impôt 50 % (article 199 sexdecies CGI)</li>
            <li>APA / PCH mobilisables</li>
        </ul>
    </div>

    <div class="section">
        <div class="section-title">6. Droits des bénéficiaires</div>
        <p>Conformément à la loi 2002-2 et au CASF :</p>
        <ul>
            <li>Respect de la dignité, intimité et vie privée</li>
            <li>Information claire et consentement éclairé</li>
            <li>Libre choix de l'intervenant et des prestations</li>
            <li>Possibilité de désigner une personne de confiance</li>
            <li>Confidentialité absolue des données personnelles</li>
            <li>Droit d'accès à tous vos documents</li>
        </ul>
    </div>

    <div class="section">
        <div class="section-title">7. Vos obligations</div>
        <ul>
            <li>Fournir un cadre de travail sûr et adapté</li>
            <li>Respecter l'intervenant (pas de tâches hors contrat)</li>
            <li>Informer OMAD en cas d'absence, hospitalisation, changement de situation</li>
            <li>Régler les salaires (via CESU) et les frais de mandat</li>
        </ul>
    </div>

    <div class="section">
        <div class="section-title">8. Protection des données personnelles (RGPD)</div>
        <ul>
            <li><strong>Responsable de traitement :</strong> OMAD Services – dpo@omadservices.com</li>
            <li><strong>Finalités :</strong> gestion des prestations, paie, suivi qualité</li>
            <li><strong>Conservation :</strong> durée du contrat + 5 ans max (prescription légale)</li>
            <li><strong>Droits :</strong> accès, rectification, opposition, effacement, portabilité</li>
        </ul>
        <p>Vous pouvez exercer vos droits à l'adresse : contact@omadservices.com</p>
    </div>

    <div class="section">
        <div class="section-title">9. Rétractation et médiation</div>
        <div class="highlight">
            <p><strong>Droit de rétractation 14 jours</strong> (contrats signés hors établissement ou à distance).</p>
            <p><strong>En cas de litige non résolu,</strong> recours gratuit à un médiateur de la consommation (art. L.612-1 Code conso).</p>
            <p><strong>Médiateur :</strong> [nom du médiateur agréé]</p>
        </div>
    </div>

    <div class="section">
        <div class="section-title">10. Réclamations et litiges</div>
        <ul>
            <li>Réclamation par écrit à OMAD (réponse sous 15 jours)</li>
            <li>Médiation consommation si besoin</li>
            <li>À défaut, compétence des tribunaux du siège social</li>
        </ul>
    </div>

    <div class="section">
        <div class="section-title">11. Assurance</div>
        <p>OMAD Services est couvert par une RC Pro.</p>
        <p>Le particulier employeur doit souscrire une RC employeur pour couvrir l'emploi d'un salarié à domicile.</p>
    </div>

    <div class="section">
        <div class="section-title">12. Suivi qualité</div>
        <ul>
            <li>Évaluation initiale des besoins (questionnaire d'accueil)</li>
            <li>Visites de suivi régulières</li>
            <li>Questionnaire de satisfaction annuel</li>
            <li>Bilan qualité trimestriel interne</li>
        </ul>
    </div>

    <div class="section">
        <div class="section-title">13. Suspension et force majeure</div>
        <p>Les prestations peuvent être suspendues en cas d'impayés, de manquement grave ou de force majeure (pandémie, catastrophe naturelle, décision administrative).</p>
    </div>

    <div class="section">
        <div class="section-title">14. Annexes remises avec le livret</div>
        <ul>
            <li>Contrat de mandat type</li>
            <li>CGS</li>
            <li>Règlement intérieur (bénéficiaires & intervenants)</li>
            <li>Grille tarifaire complète</li>
            <li>Charte des droits et libertés de la personne accompagnée</li>
            <li>Attestation RC Pro</li>
            <li>Fiche de réclamation / médiation</li>
        </ul>
    </div>

    <div class="section">
        <div class="section-title">Contact</div>
        <p><strong>OMAD Services</strong><br>
        30 bis Rue des Bondoires – 18230 Saint-Doulchard<br>
        📞 06 67 72 73 30 – ✉ contact@omadservices.com</p>
    </div>

    <div class="footer">
        <p>Document généré le ${new Date().toLocaleDateString('fr-FR')} - OMAD Services SAS - RCS Bourges 922 592 662</p>
    </div>
</body>
</html>
`;

// Template du Règlement Intérieur Bénéficiaires
export const ReglementInterieurBeneficiairesTemplate = ({ client }) => `
<!DOCTYPE html>
<html lang="fr">
<head>
    <meta charset="UTF-8">
    <meta name="viewport" content="width=device-width, initial-scale=1.0">
    <title>Règlement Intérieur Bénéficiaires - OMAD Services</title>
    <style>
        body { font-family: Arial, sans-serif; line-height: 1.6; margin: 0; padding: 20px; }
        .header { text-align: center; margin-bottom: 30px; border-bottom: 2px solid #333; padding-bottom: 20px; }
        .section { margin-bottom: 25px; }
        .section-title { font-weight: bold; font-size: 16px; margin-bottom: 10px; color: #2c3e50; }
        .footer { margin-top: 50px; font-size: 12px; color: #666; text-align: center; }
    </style>
</head>
<body>
    <div class="header">
        <h1>RÈGLEMENT INTÉRIEUR – BÉNÉFICIAIRES</h1>
        <h2>OMAD SERVICES – Droits, obligations et engagements réciproques</h2>
    </div>

    <div class="section">
        <div class="section-title">Article I – Droits fondamentaux</div>
        <ul>
            <li>Respect, dignité, vie privée</li>
            <li>Information claire sur prestations, tarifs, contrats et modifications</li>
            <li>Droit d'accès aux données personnelles (RGPD)</li>
            <li>Droit de désigner une personne de confiance (loi 2002-2)</li>
        </ul>
    </div>

    <div class="section">
        <div class="section-title">Article II – Obligations du bénéficiaire</div>
        <ul>
            <li>Fournir un environnement sûr, propre et adapté</li>
            <li>Respecter l'intervenant (courtoisie, absence de comportements abusifs)</li>
            <li>Prévenir OMAD de tout changement (absence, hospitalisation, déménagement)</li>
            <li>Ne pas demander de tâches interdites (travaux dangereux, successions, etc.)</li>
        </ul>
    </div>

    <div class="section">
        <div class="section-title">Article III – Horaires, modifications et annulations</div>
        <ul>
            <li>Respect des horaires fixés au contrat</li>
            <li>Prévenir au moins 48h avant toute modification/annulation (sauf urgence)</li>
            <li>En cas d'annulation tardive, OMAD peut facturer la prestation prévue</li>
        </ul>
    </div>

    <div class="section">
        <div class="section-title">Article IV – Tarification et paiement</div>
        <ul>
            <li>Tarifs définis dans le contrat ou mandat</li>
            <li>Paiement dans les délais convenus</li>
            <li>En cas de retard, procédure de relance et suspension possible</li>
        </ul>
    </div>

    <div class="section">
        <div class="section-title">Article V – Réclamations et litiges</div>
        <ul>
            <li>Toute réclamation doit être adressée par écrit à OMAD (réponse sous 15 jours ouvrés)</li>
            <li>Possibilité de recourir à un médiateur de la consommation en cas de litige persistant</li>
            <li>Tribunal compétent en dernier recours</li>
        </ul>
    </div>

    <div class="section">
        <div class="section-title">Article VI – Respect et sécurité</div>
        <ul>
            <li>Garantir la sécurité de l'intervenant (logement non dangereux, animaux maîtrisés)</li>
            <li>Fournir les produits/matériels nécessaires</li>
            <li>Ne pas demander de tâches hors contrat ou illégales</li>
            <li>Respecter l'intimité professionnelle de l'intervenant</li>
        </ul>
    </div>

    <div class="section">
        <div class="section-title">Article VII – Engagement réciproque</div>
        <ul>
            <li>Collaboration avec OMAD pour le suivi et l'évaluation de la qualité</li>
            <li>Suspension ou rupture immédiate possible en cas de manquement grave (violence, impayés, mise en danger)</li>
        </ul>
    </div>

    <div class="section">
        <div class="section-title">Article VIII – Force majeure</div>
        <p>Les prestations peuvent être suspendues ou réorganisées en cas de force majeure (catastrophe naturelle, pandémie, décision administrative).</p>
    </div>

    <div class="footer">
        <p>Document généré le ${new Date().toLocaleDateString('fr-FR')} - OMAD Services SAS - RCS Bourges 922 592 662</p>
    </div>
</body>
</html>
`;

// Template du Règlement Intérieur Intervenants
export const ReglementInterieurIntervenantsTemplate = ({ intervenant }) => `
<!DOCTYPE html>
<html lang="fr">
<head>
    <meta charset="UTF-8">
    <meta name="viewport" content="width=device-width, initial-scale=1.0">
    <title>Règlement Intérieur Intervenants - OMAD Services</title>
    <style>
        body { font-family: Arial, sans-serif; line-height: 1.6; margin: 0; padding: 20px; }
        .header { text-align: center; margin-bottom: 30px; border-bottom: 2px solid #333; padding-bottom: 20px; }
        .section { margin-bottom: 25px; }
        .section-title { font-weight: bold; font-size: 16px; margin-bottom: 10px; color: #2c3e50; }
        .footer { margin-top: 50px; font-size: 12px; color: #666; text-align: center; }
    </style>
</head>
<body>
    <div class="header">
        <h1>RÈGLEMENT INTÉRIEUR – INTERVENANTS</h1>
        <h2>OMAD SERVICES – Droits, devoirs et obligations professionnelles</h2>
    </div>

    <div class="section">
        <div class="section-title">Article I – Objet et champ d'application</div>
        <p>S'applique à tous les intervenants salariés ou conventionnés.</p>
        <p>Précise droits, devoirs et obligations professionnelles.</p>
    </div>

    <div class="section">
        <div class="section-title">Article II – Déontologie et comportement professionnel</div>
        <ul>
            <li>Respect de la dignité, vie privée, convictions du bénéficiaire</li>
            <li>Neutralité politique, religieuse, philosophique</li>
            <li>Confidentialité absolue (secret professionnel & RGPD)</li>
            <li>Interdictions : divulgation d'informations, photos/vidéos, acceptation de dons sans autorisation</li>
        </ul>
    </div>

    <div class="section">
        <div class="section-title">Article III – Missions et limites</div>
        <ul>
            <li>Réaliser uniquement les tâches prévues au contrat</li>
            <li>Stimuler l'autonomie du bénéficiaire sans substitution abusive</li>
            <li>Interdiction : soins médicaux réservés, travaux dangereux, implication dans affaires personnelles/successorales</li>
        </ul>
    </div>

    <div class="section">
        <div class="section-title">Article IV – Hygiène, sécurité et santé</div>
        <ul>
            <li>Respect des règles d'hygiène et de sécurité</li>
            <li>Formation continue obligatoire : gestes et postures, premiers secours, bientraitance</li>
            <li>Port d'EPI (gants, masques, tablier) lorsque nécessaire</li>
            <li>Droit de retrait en cas de danger grave et imminent</li>
            <li>Déclaration immédiate de tout accident ou incident</li>
        </ul>
    </div>

    <div class="section">
        <div class="section-title">Article V – Organisation du travail</div>
        <ul>
            <li>Respect strict des plannings</li>
            <li>Obligation de prévenir OMAD et le bénéficiaire en cas de retard/absence</li>
            <li>Absences injustifiées peuvent donner lieu à sanctions</li>
            <li>OMAD organise un remplacement lorsque possible</li>
        </ul>
    </div>

    <div class="section">
        <div class="section-title">Article VI – Assurance et responsabilité</div>
        <ul>
            <li>Chaque intervenant doit disposer d'une assurance RC professionnelle valide</li>
            <li>OMAD n'est pas responsable des dommages causés par une mission hors contrat</li>
        </ul>
    </div>

    <div class="section">
        <div class="section-title">Article VII – Discipline et sanctions</div>
        <ul>
            <li>Sanctions graduées : avertissement oral → écrit → suspension → rupture</li>
            <li>Fautes graves (violence, vol, divulgation de données, abus financier) = rupture immédiate</li>
            <li>L'intervenant a droit à un entretien avant sanction définitive</li>
        </ul>
    </div>

    <div class="section">
        <div class="section-title">Article VIII – Force majeure</div>
        <p>Les missions peuvent être suspendues en cas de force majeure (pandémie, catastrophe, décision administrative).</p>
    </div>

    <div class="section">
        <div class="section-title">Article IX – Protection des données</div>
        <ul>
            <li>Les données personnelles des bénéficiaires doivent être protégées strictement</li>
            <li>Durée de conservation limitée au nécessaire</li>
            <li>Toute violation sera sanctionnée</li>
        </ul>
    </div>

    <div class="footer">
        <p>Document généré le ${new Date().toLocaleDateString('fr-FR')} - OMAD Services SAS - RCS Bourges 922 592 662</p>
    </div>
</body>
</html>
`;

// Template de l'Attestation Fiscale Annuelle
export const AttestationFiscaleTemplate = ({ client, periode, montants }) => `
<!DOCTYPE html>
<html lang="fr">
<head>
    <meta charset="UTF-8">
    <meta name="viewport" content="width=device-width, initial-scale=1.0">
    <title>Attestation Fiscale Annuelle - OMAD Services</title>
    <style>
        body { font-family: Arial, sans-serif; line-height: 1.6; margin: 0; padding: 20px; }
        .header { text-align: center; margin-bottom: 30px; border-bottom: 2px solid #333; padding-bottom: 20px; }
        .section { margin-bottom: 25px; }
        .section-title { font-weight: bold; font-size: 16px; margin-bottom: 10px; color: #2c3e50; }
        .table { width: 100%; border-collapse: collapse; margin: 10px 0; }
        .table th, .table td { border: 1px solid #ddd; padding: 8px; text-align: left; }
        .table th { background-color: #f8f9fa; }
        .highlight { background-color: #fff3cd; padding: 10px; border-left: 4px solid #ffc107; margin: 10px 0; }
        .footer { margin-top: 50px; font-size: 12px; color: #666; text-align: center; }
    </style>
</head>
<body>
    <div class="header">
        <h1>ATTESTATION FISCALE ANNUELLE</h1>
        <h2>Conformément à l'article 199 sexdecies du Code Général des Impôts</h2>
    </div>

    <div class="section">
        <p><strong>OMAD Services</strong> – SAS au capital de 500 €<br>
        RCS Bourges : 922 592 662 – SIRET : 922 592 662 00014<br>
        Siège social : 30 bis Rue des Bondoires – 18230 Saint-Doulchard<br>
        📧 contact@omadservices.com – 📞 06 67 72 73 30</p>
    </div>

    <div class="section">
        <p><strong>Bénéficiaire :</strong><br>
        Nom/Prénom : ${client?.firstName || '______'} ${client?.lastName || '______'}<br>
        Adresse : ${client?.address || '______'}</p>
    </div>

    <div class="section">
        <div class="section-title">Période concernée : Année civile ${periode || '______'}</div>
    </div>

    <div class="section">
        <div class="section-title">1. Détail des prestations ouvrant droit à avantage fiscal</div>
        <table class="table">
            <tr>
                <th>Nature du service</th>
                <th>Nombre d'heures</th>
                <th>Montant acquitté (€)</th>
                <th>Dont financé CESU/préfinancement (€)</th>
            </tr>
            <tr>
                <td>Aide à la personne</td>
                <td>${montants?.heuresAide || '____'}</td>
                <td>${montants?.montantAide || '____'} €</td>
                <td>${montants?.cesuAide || '____'} €</td>
            </tr>
            <tr>
                <td>Entretien du logement</td>
                <td>${montants?.heuresEntretien || '____'}</td>
                <td>${montants?.montantEntretien || '____'} €</td>
                <td>${montants?.cesuEntretien || '____'} €</td>
            </tr>
            <tr>
                <td>Accompagnement extérieur</td>
                <td>${montants?.heuresAccompagnement || '____'}</td>
                <td>${montants?.montantAccompagnement || '____'} €</td>
                <td>${montants?.cesuAccompagnement || '____'} €</td>
            </tr>
            <tr>
                <td><strong>TOTAL annuel</strong></td>
                <td><strong>${montants?.totalHeures || '____'}</strong></td>
                <td><strong>${montants?.totalMontant || '____'} €</strong></td>
                <td><strong>${montants?.totalCesu || '____'} €</strong></td>
            </tr>
        </table>
    </div>

    <div class="section">
        <div class="section-title">2. Mentions légales</div>
        <ul>
            <li>Les prestations déclarées relèvent de l'article D. 7231-1 du Code du Travail (« Services à la personne »)</li>
            <li>L'attestation est délivrée conformément à l'article 199 sexdecies du CGI</li>
        </ul>
        <div class="highlight">
            <p><strong>⚠️ Cette attestation ne vaut pas validation automatique par l'administration fiscale.</strong> Le droit effectif au crédit/réduction d'impôt dépend de la situation fiscale du bénéficiaire.</p>
        </div>
    </div>

    <div class="section">
        <p>Fait à Saint-Doulchard, le ___ / ___ / ____</p>
        <p>Signature et cachet d'OMAD Services</p>
    </div>

    <div class="footer">
        <p>Document généré le ${new Date().toLocaleDateString('fr-FR')} - OMAD Services SAS - RCS Bourges 922 592 662</p>
    </div>
</body>
</html>
`;

// Template de la Charte des Droits et Libertés
export const CharteDroitsLibertesTemplate = ({ client }) => `
<!DOCTYPE html>
<html lang="fr">
<head>
    <meta charset="UTF-8">
    <meta name="viewport" content="width=device-width, initial-scale=1.0">
    <title>Charte des Droits et Libertés - OMAD Services</title>
    <style>
        body { font-family: Arial, sans-serif; line-height: 1.6; margin: 0; padding: 20px; }
        .header { text-align: center; margin-bottom: 30px; border-bottom: 2px solid #333; padding-bottom: 20px; }
        .section { margin-bottom: 25px; }
        .section-title { font-weight: bold; font-size: 16px; margin-bottom: 10px; color: #2c3e50; }
        .footer { margin-top: 50px; font-size: 12px; color: #666; text-align: center; }
    </style>
</head>
<body>
    <div class="header">
        <h1>CHARTE DES DROITS ET LIBERTÉS</h1>
        <h2>OMAD Services – Conformément à la loi n° 2002-2 du 2 janvier 2002 et au CASF</h2>
    </div>

    <div class="section">
        <div class="section-title">Article 1 – Respect de la dignité et de la vie privée</div>
        <p>Toute personne accompagnée a droit au respect de sa dignité, de son intimité et de sa vie privée.</p>
    </div>

    <div class="section">
        <div class="section-title">Article 2 – Non-discrimination</div>
        <p>Aucun bénéficiaire ne peut être écarté en raison de son âge, état de santé, handicap, origine, convictions, orientation sexuelle, etc.</p>
    </div>

    <div class="section">
        <div class="section-title">Article 3 – Droit à l'information</div>
        <p>Le bénéficiaire doit recevoir une information claire et compréhensible sur ses droits, ses obligations, les tarifs et les conditions de service.</p>
    </div>

    <div class="section">
        <div class="section-title">Article 4 – Libre choix</div>
        <p>La personne conserve la liberté de choisir son intervenant et de modifier ou résilier son contrat.</p>
    </div>

    <div class="section">
        <div class="section-title">Article 5 – Consentement éclairé</div>
        <p>Aucune intervention ne peut être réalisée sans l'accord de la personne ou de son représentant légal.</p>
    </div>

    <div class="section">
        <div class="section-title">Article 6 – Participation active</div>
        <p>Le bénéficiaire participe à l'élaboration de son projet d'accompagnement et peut exprimer ses souhaits et préférences.</p>
    </div>

    <div class="section">
        <div class="section-title">Article 7 – Protection des données personnelles</div>
        <p>Les informations collectées sont confidentielles, sécurisées et utilisées uniquement pour l'exécution des prestations (RGPD).</p>
    </div>

    <div class="section">
        <div class="section-title">Article 8 – Personne de confiance</div>
        <p>Chaque bénéficiaire peut désigner une personne de confiance chargée de l'assister dans ses démarches.</p>
    </div>

    <div class="section">
        <div class="section-title">Article 9 – Droit de réclamation et médiation</div>
        <p>Toute réclamation peut être formulée auprès d'OMAD Services.</p>
        <p>En cas de désaccord, recours possible à un médiateur de la consommation.</p>
    </div>

    <div class="section">
        <div class="section-title">Article 10 – Sécurité et bientraitance</div>
        <p>OMAD Services s'engage à prévenir toute situation de maltraitance et à garantir un environnement sûr, respectueux et bienveillant.</p>
    </div>

    <div class="footer">
        <p>OMAD Services – SAS<br>
        📞 06 67 72 73 30 – ✉ contact@omadservices.com<br>
        Document généré le ${new Date().toLocaleDateString('fr-FR')}</p>
    </div>
</body>
</html>
`;

// Export de tous les templates
export const DOCUMENT_TEMPLATES = {
    MANDAT: MandatTemplate,
    CGS: CGSTemplate,
    CONTRAT_TRAVAIL: ContratTravailTemplate,
    LIVRET_ACCUEIL: LivretAccueilTemplate,
    REGLEMENT_BENEFICIAIRES: ReglementInterieurBeneficiairesTemplate,
    REGLEMENT_INTERVENANTS: ReglementInterieurIntervenantsTemplate,
    ATTESTATION_FISCALE: AttestationFiscaleTemplate,
    CHARTE_DROITS: CharteDroitsLibertesTemplate
};

// Fonction utilitaire pour générer un document
export const generateDocument = (templateType, data = {}) => {
    const template = DOCUMENT_TEMPLATES[templateType];
    if (!template) {
        throw new Error(`Template ${templateType} non trouvé`);
    }
    return template(data);
};

// Fonction pour obtenir la liste des documents disponibles (uniquement documents clients)
export const getAvailableDocuments = () => [
    { id: 'MANDAT', label: 'Contrat de Prestation de Mandat', description: 'Document principal définissant la relation contractuelle' },
    { id: 'CGS', label: 'Conditions Générales de Service', description: 'Règles générales applicables aux prestations' },
    { id: 'CONTRAT_TRAVAIL', label: 'Contrat de Travail', description: 'Contrat entre particulier employeur et intervenant' },
    { id: 'REGLEMENT_BENEFICIAIRES', label: 'Règlement Intérieur Bénéficiaires', description: 'Règles de fonctionnement pour les bénéficiaires' },
    { id: 'REGLEMENT_INTERVENANTS', label: 'Règlement Intérieur Intervenants', description: 'Règles de conduite pour les intervenants' },
    { id: 'ATTESTATION_FISCALE', label: 'Attestation Fiscale Annuelle', description: 'Document pour le crédit d\'impôt' }
];
